import { Textarea } from '@mantine/core'
import TextareaClasses from './styles.module.css'

export default Textarea.extend({
    defaultProps: { radius: 'lg', size: 'lg' },
    classNames: TextareaClasses,
})
